import { productColors } from '@givebutter/util';
import styled, { css } from 'styled-components';

const ListItemStyles = css`
    cursor: pointer;
    padding: 0.5rem;
    font-size: 14px;
    font-weight: 500;
    line-height: 1rem;
    list-style-type: none;
    user-select: none;
    border-radius: ${props => props.theme.radius.default};

    &:hover,
    &:focus {
        color: inherit;
        background-color: ${productColors.gray[200]}7f;
    }
`;
const ListItem = styled.li`
    ${ListItemStyles};
    &[aria-selected='true'] {
        color: inherit;
        background-color: ${productColors.gray[200]}7f;
    }
`;

export { ListItem, ListItemStyles };
